import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Observable, of} from 'rxjs';
import {Injectable} from '@angular/core';
import {catchError, delay, map} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {UrlService} from '../../services/url.service';
import {ResponseService} from '../../services/response.service';
import {RequestConfig} from '../../../configs/request.config';

@Injectable({ providedIn: 'root' })
export class BreadcrumbsResolver implements Resolve<string> {
  constructor(private _http: HttpClient,
              private _urlService: UrlService,
              private _responseService: ResponseService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any>|any {

    const params = parseInt(route.params.id);
    const key = route.routeConfig.data.key;
    const api = 'api/breadcrumbs/get';

    const body = {};
    body[key] = params;
    return this._http.post(this._urlService.breadcrumbs(), body, RequestConfig.options)
      .pipe(map(res => {
          const error = this._responseService.parseError(res);
          if (error) throw new Error(error);
          return this._responseService.parseResponse(res);
        }),
        catchError(err => {
          console.log(err);
          this._responseService.parseUnhandledError(err);
          throw err;
        }),);;
  }
}
